/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Topbar/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import FilterByStatus from './FilterByStatus/index'
import NewMessageAction from './NewMessageAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Topbar({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Topbar.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<NewMessageAction
  viewPath={`${viewPath}/NewMessageAction`}
/>
<FilterByStatus
  viewPath={`${viewPath}/FilterByStatus`}
/>
</div>
{children}
</React.Fragment>)
}